// Dialog keys for GroupDialogContext
export const DIALOG_KEYS = {
  GROUP_ADD: 'groupAdd',
  GROUP_DELETE: 'groupDelete',
  GROUP_EDIT_NAME: 'groupEditName',
  SUB_GROUP_ADD: 'subGroupAdd',
  SUB_GROUP_EDIT_NAME: 'subGroupEditName',
  SUB_GROUP_DELETE: 'subGroupDelete',
  DELETE_SUBSCRIBER_FROM_GROUP: 'deleteSubscriberFromGroup',
  ADD_SUBSCRIBER: 'addSubscriber',
  GROUP_LIMIT: 'groupLimit',
}
